import type { PickD3Scale } from '@visx/scale'

export function useD3ChartGridOffset(xScale: PickD3Scale<'band', number, number>, xMax: number) {
  const step = xScale.step()
  return {
    gridColumnOffset: step / -2,
    extraGridColumnX: xMax - (step - xScale.bandwidth()) / 2,
  }
}
